'use client'
import {
  CollapsableText_default,
  MarkdownRender_default
} from "./chunk-MAJWJHOB.mjs";
import {
  DecoratedSection_default
} from "./chunk-HJCFOVNG.mjs";
import {
  ContentfulButton_default
} from "./chunk-K3ITZBKW.mjs";
import {
  ContentfulMedia_default
} from "./chunk-BYRNGPWN.mjs";

// src/components/about/AboutSectionWbk.tsx
import { Typography } from "@wbk/ui";
import { jsx, jsxs } from "react/jsx-runtime";
var AboutSectionWbk = ({ section }) => {
  var _a, _b;
  const cards = section.contentCollection.items;
  return /* @__PURE__ */ jsxs(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_about_section_${section.id}`,
      children: [
        /* @__PURE__ */ jsxs("div", { className: "relative flex flex-col items-center justify-center space-y-4 text-center", children: [
          section.title && /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
            /* @__PURE__ */ jsx(Typography, { as: "h2", variant: "heading-L", children: section.title }),
            section.subtitle && /* @__PURE__ */ jsx(Typography, { color: "text-secondary", children: section.subtitle })
          ] }),
          section.collapsableDescription && /* @__PURE__ */ jsx(
            CollapsableText_default,
            {
              text: section.collapsableDescription,
              minimum: 6,
              btnProps: { "aria-label": `Read More About ${section.title}` }
            }
          ),
          /* @__PURE__ */ jsx("ul", { className: "flex flex-wrap gap-6 md:gap-10", children: cards.length > 0 && cards.map((item, i) => /* @__PURE__ */ jsxs("li", { className: "flex items-start gap-4", children: [
            item.icon && /* @__PURE__ */ jsx(
              ContentfulMedia_default,
              {
                media: item.icon,
                className: "h-8 w-8 object-contain",
                format: null
              }
            ),
            /* @__PURE__ */ jsxs("div", { className: "text-start", children: [
              /* @__PURE__ */ jsx(Typography, { className: "font-semibold", children: item.title }),
              item.description && /* @__PURE__ */ jsx("div", { className: "text-text-secondary", children: /* @__PURE__ */ jsx(MarkdownRender_default, { text: item.description, prose: false }) })
            ] })
          ] }, i)) })
        ] }),
        !!((_b = (_a = section.webLinksCollection) == null ? void 0 : _a.items) == null ? void 0 : _b.length) && /* @__PURE__ */ jsx("div", { className: "mt-6 flex flex-wrap items-center justify-center gap-4", children: section.webLinksCollection.items.map((link) => /* @__PURE__ */ jsx(ContentfulButton_default, { link }, link.id)) })
      ]
    }
  );
};
var AboutSectionWbk_default = AboutSectionWbk;

// src/components/about/AboutImageSection.tsx
import { Typography as Typography2 } from "@wbk/ui";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var AboutImageSection = ({ section }) => {
  var _a, _b, _c;
  const cards = section.contentCollection.items;
  const mainCard = cards == null ? void 0 : cards[0];
  if (!mainCard) return null;
  const iconCards = cards == null ? void 0 : cards.slice(1);
  const reverse = section.renderType === "about-image-section-reverse";
  const image = mainCard.image11 || mainCard.image;
  return /* @__PURE__ */ jsxs2(
    DecoratedSection_default,
    {
      section,
      className: "container",
      "data-testid": `section_about_image_section_${section.id}`,
      children: [
        section.title && /* @__PURE__ */ jsxs2("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx2(Typography2, { as: "h2", variant: "heading-L", children: section.title }),
          section.subtitle && /* @__PURE__ */ jsx2(Typography2, { color: "text-secondary", children: section.subtitle })
        ] }),
        /* @__PURE__ */ jsxs2(
          "div",
          {
            className: `flex flex-col gap-10 ${reverse ? "flex-col-reverse md:flex-row-reverse" : "md:flex-row"}`,
            children: [
              /* @__PURE__ */ jsxs2("div", { className: "space-y-L flex-grow", children: [
                /* @__PURE__ */ jsxs2("div", { className: "space-y-M w-full", children: [
                  /* @__PURE__ */ jsx2(Typography2, { variant: "heading-M", children: mainCard.title }),
                  /* @__PURE__ */ jsx2(
                    CollapsableText_default,
                    {
                      text: mainCard.description,
                      markdown: typeof mainCard.description === "string",
                      minimum: 6
                    }
                  ),
                  !!((_b = (_a = section.webLinksCollection) == null ? void 0 : _a.items) == null ? void 0 : _b.length) && /* @__PURE__ */ jsx2("div", { className: "gap-M mt-6 flex flex-wrap", children: section.webLinksCollection.items.map((link) => /* @__PURE__ */ jsx2(ContentfulButton_default, { link }, link.id)) })
                ] }),
                iconCards.length > 0 && /* @__PURE__ */ jsx2("div", { className: "gap-S pt-L border-paper-level-1 grid grid-cols-1 border-t sm:grid-cols-2", children: iconCards.map((card) => /* @__PURE__ */ jsxs2("div", { className: "gap-S flex items-center", children: [
                  /* @__PURE__ */ jsx2(ContentfulMedia_default, { media: card.icon, className: "h-6 w-6 shrink-0" }),
                  /* @__PURE__ */ jsxs2("div", { className: "flex items-center gap-1", children: [
                    /* @__PURE__ */ jsx2(Typography2, { variant: "body-S", color: "text-secondary", children: card.title }),
                    /* @__PURE__ */ jsx2(Typography2, { variant: "body-S", children: card.subtitle })
                  ] })
                ] }, card.id)) })
              ] }),
              /* @__PURE__ */ jsx2(
                ContentfulMedia_default,
                {
                  media: image,
                  poster: (_c = mainCard.image) == null ? void 0 : _c.url,
                  ratio: "3x1",
                  placeholder: true,
                  controls: true,
                  className: "rounded-M h-48 w-full shrink-0 overflow-hidden object-cover object-center md:h-96 md:w-1/2"
                }
              )
            ]
          }
        )
      ]
    }
  );
};
var AboutImageSection_default = AboutImageSection;

export {
  AboutSectionWbk_default,
  AboutImageSection_default
};
//# sourceMappingURL=chunk-PBNZBYFE.mjs.map